import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Button,
  Input,
  Text,
  Image,
  VStack,
  Flex,
  HStack,
  Stack,
  SkeletonText,
} from "@chakra-ui/react";
import {
  updateDoctorNotes,
  GetDoctorNotes,
  FetchLatestCCList,
  GetAdvanceChiefComplaints,
} from "../../../middleware/services/visits/patient-overview/updatedoctornotes";
import PrimaryButton from "../../primary-button";
import { COLORS } from "../../styles/colors";
import useLoader from "../../loader/loaderstates";
import Loader from "../../loader/loader";
import { ChatAudioManager } from "./cheif-complaint-audio/chatVoiceManager";
import { useTranscriber } from "./cheif-complaint-audio/useTranscriber";
import { actionAccessMain, getLoginID, handleAlphaDotAndSpace } from "../../../auth";
import { CorrectChiefComplaintUsingAI } from "../../../middleware/services/visits/aicalls";
import DynamicModal from "../../dynamic-modal";
import PrimaryInput from "../../primary-input";

const DoctorComplaintInputCPUCard = ({
  patientId,
  doctorId,
  appointmentId,
  showSuccessToast,
  showErrorToast,
  fetchDoctorNotesEmptyIndication,
  submitOnTabSwitch,
}) => {
  //------------------speech to text
  const activeTranscriber = useTranscriber();

  const [typing, setTyping] = useState(false); // Typing indicator state

  const [placeholder, setPlaceholder] = useState(
    "Click anywhere to start typing...."
  );

  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      setPlaceholder("Click anywhere to start typing....");
      setTyping(false);
    }
  }, [activeTranscriber?.output]);

  //------------------other functionality
  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [initialText, setInitialText] = useState("");

  const { isLoading, showLoader, dismissLoader } = useLoader();

  const fetchDoctorNotes = async () => {
    const inputToFetch = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId,
      },
    };

    showLoader();
    try {
      const data = await GetDoctorNotes(inputToFetch.input);
      const chiefComplaint =
        data?.output?.data?.chiefcomplaint?.chiefcomplaint || "";
      // console.log(chiefComplaint);
      setInitialText(chiefComplaint);
      setValue("textField", chiefComplaint);
    } catch (error) {
      console.error("Error fetching Doctor Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  const UpdateChiefComplaint = async (data) => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        chiefcomplaint: data.textField,
      },
    };

    showLoader();
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("Chief Complaint Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  const correctChiefComplaint = async (cc_text) => {
    const inputToSave = {
      input: {
        text: cc_text,
      },
    };

    // console.log(inputToSave)

    showLoader();
    try {
      const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
      if (result) {
        showSuccessToast("Updated Chief Complaint");
        setValue("textField", result?.text);
      }
    } catch (error) {
      console.error("Error in Correct cc ai call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
  };

  const onSubmit = (data) => {
    setIsButtonDisabled(true); // Disable button on submit
    UpdateChiefComplaint(data);
    fetchDoctorNotesEmptyIndication();
  };

  // submit on tab switch and submit button is enalbed
  useEffect(() => {
    if (!isButtonDisabled && submitOnTabSwitch) {
      handleSubmit(onSubmit)();
    }
  }, [submitOnTabSwitch]);

  useEffect(() => {
    fetchDoctorNotes();
  }, []);

  useEffect(() => {
    if (textFieldValue !== initialText) {
      setIsButtonDisabled(false); // Enable button if text field value changes
    } else {
      setIsButtonDisabled(true); // Disable button if text field value is unchanged
    }
  }, [textFieldValue, initialText]);

    const [searchValue, setSearchValue] = useState('')
    const [showReportNamesDropdown , setShowReportNamesDropdown] = useState(false)
    const [labTestNamesFiltered , setLabTestNamesFiltered] = useState([]);
    const [labTestNames , setLabTestNames] = useState([])
    const [selectedComplaint, setSelectedComplaint] = useState(null);
    const [ccList, setCCList] = useState([]);
    const [boolValForSuggestions , setBoolValForSuggestions] = useState(true);
    const advanceCheifComplaints = useRef();
  const openChiefComplaint = async () => {
    // Just open the modal without API call
    setSearchValue('');
    setShowReportNamesDropdown(false);
    setLabTestNames([]);
    setLabTestNamesFiltered([]);
    advanceCheifComplaints.current.openModal();
  };
  
  const handleComplaintSelection = (complaintText) => {
    // Find the full complaint object that matches the selected text
    const selected = ccList.find(item => item.chiefcomplaint === complaintText.target.textContent);
    setSelectedComplaint(selected);
    console.log(complaintText, "selected complaintText")
    setValue("textField", selected?.chiefcomplaint || "");
  };

  useEffect(() => {
    getCC()
  }, [])

  const getCC = async() => {
      showLoader();
      const input = {
        appointmentid: appointmentId,
      }
      try {
        const result = await FetchLatestCCList(input);
        console.log(result, "result of latest cc")
  
        if(result && result.output.data) {
          setCCList(result.output.data)
        }else {
          setCCList([])
        }
  
      } catch(error) {
        console.error("Something went wrong.", error)
      }
      dismissLoader();
    }

      
      const handleReportNameChange = async (value) => {
        setSearchValue(value);
        
        // Only call API if input length >= 3
        if (value.length >= 3) {
          showLoader();
          try {
            const input = {
              "type": "chiefcomplaints",
              "searchtext": value,
              'doctorid': getLoginID(),
            };
            const result = await GetAdvanceChiefComplaints(input);
            
            if(result && result.output.result === 'success') {
              setLabTestNames(result.output.data);
              setLabTestNamesFiltered(result.output.data);
              setShowReportNamesDropdown(true);
            }
          } catch (error) {
            console.log('Something went wrong.', error);
          } finally {
            dismissLoader();
          }
        } else {
          // Hide dropdown if less than 3 characters
          setShowReportNamesDropdown(false);
        }
      };

      const handleInputFocus = () => {
        if (labTestNames.length > 0) {
          setShowReportNamesDropdown(true);
        }
      };

      const handleSelectComplaint = (suggestion) => {
        // Get current textarea value
        const currentValue = getValues("textField") || "";
        
        const newValue = currentValue 
          ? `${currentValue}, ${suggestion.subtype}`
          : suggestion.subtype;
        
        setValue("textField", newValue);
        advanceCheifComplaints.current.closeModal();
        
        setSearchValue("");
        setShowReportNamesDropdown(false);
      };

      const {getValues } = useForm();

      const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};
  return (
    <Flex
      direction="column"
      height={{ base: "100%", md: "calc(100vh - 4rem)" }}
      align="center"
      justify="center"
      bg="white"
    >
      {isLoading && <Loader miniLoader={true} />}
      <Box
        as="form"
        onSubmit={handleSubmit(onSubmit)}
        padding={{ base: "0", md: "4" }}
        width={{ base: "100%", md: "98%" }}
        height="95%"
        position={{ base: "unset", md: "absolute" }}
        bg="white"
        pt={"2px"}
      >
        <VStack spacing={{ base: "2", md: "4" }} height="85%">
          <Box
            display='flex' gap='0.5rem' alignItems='end'
            width="100%"
            position="relative"
          >
            <Input
              {...register("textField")}
              height={{ base: "100px", md: "100%" }}
              padding="2"
              resize="none"
              outline="none"
              border="1px solid #e2e8f0"
              borderRadius="10px"
              sx={{
                "&:focus": { outline: "none", borderColor: "none" },
                _active: { borderColor: "none" },
                _focus: { borderColor: "none" },
              }}
              w='100%'
              as="textarea"
              bg={"#f9fafb"}
              disabled={typing} // Disable when AI typing is true
              style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
            />
            <Text
              position="absolute"
              bottom="2"
              left="50%"
              transform="translateX(-60%)"
              fontSize={{ base: "xs", md: "sm" }}
              color="gray.500"
              w={{ base: "100%", md: "unset" }}
              textAlign={{ base: "center", md: "unset" }}
            >
              {placeholder}
            </Text>
            <PrimaryButton 
              buttonText="Advance" 
              onClick={openChiefComplaint}
              ml={2}
              variant='mdBtn'
              float='right'
              btnStyle={{w:'fit-content',m:0,h:'35px'}}
              // isDisabled={!manualreportname} // Disable if no report name
            />
          </Box>

          <Box width='100%' padding={{base:'0.5rem', md:'1rem'}} maxH='calc(100% - 10rem)' overflow="hidden auto" border='1px solid #E6E7E9' borderRadius='8px'>
            {isLoading ? 
            (<Stack>
              <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
            </Stack>) : (
            <Flex flexWrap='wrap' w='100%'>
            {ccList.map((response, index) => (
              <Button
                key={index}
                borderRadius="full"
                onClick={handleComplaintSelection}
                bg={selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? "black" : "white"}
                color={selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? "white" : "black"}
                leftIcon={
                  selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? (
                    <Image src="/assets/svgs/white-ok.svg" boxSize="1em" />
                  ) : null
                }
                variant="solid"
                boxShadow={
                  selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.2)"
                }
                _hover={{
                  bg: selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? "black" : "white", // Darker when hovered
                }}
                _active={{
                  bg: selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? "black" : "white", // Slightly dim when clicked
                }}
                border={selectedComplaint?.chiefcomplaint == response?.chiefcomplaint ? "none" : "1px solid #E6E7E9"}

                // existing lines of code
                // fontSize={{ base: "sm", md: "md" }}
                // h={{ base: "1rem", md: "2.5rem" }}
                // p={{ base: "0.5rem", md: "1rem" }}
                // m={1}

                // newly added lines
                fontSize={{ base: "xs", md: "sm" }}
                minH={{ base: "2rem", md: "2.5rem" }} // Changed from h to minH for flexibility
                px={{ base: "0.75rem", md: "1rem" }} // Horizontal padding only
                py={{ base: "0.5rem", md: "0.75rem" }} // Vertical padding for height
                m={1}
                whiteSpace="normal" // Allow text to wrap
                wordWrap="break-word" // Break long words if needed
                textAlign="center" // Center the text
                lineHeight="shorter" // Tighter line height for wrapped text
                maxW="100%" // Ensure button doesn't exceed container width
              >
                {response.chiefcomplaint}
              </Button>
              ))}
            </Flex>
            )}
          </Box>
          <HStack
            p={2}
            // position="absolute"
            bottom="0"
            width="100%"
            alignItems={{ base: "center", md: "flex-end" }}
          >
            <ChatAudioManager
              transcriber={activeTranscriber}
              setPlaceholder={setPlaceholder}
              setTyping={setTyping}
            />
            <Box
  as="button"
  border="1px solid #E6E7E9"
  borderRadius="full"
  w="36px"
  h="auto"
  p="10px"
  display="flex"
  justifyContent="center"
  alignItems="center"
  cursor={textFieldValue && isChatbotAllowed() ? "pointer" : "not-allowed"}
  opacity={textFieldValue && isChatbotAllowed() ? 1 : 0.5}
  pointerEvents={textFieldValue && isChatbotAllowed() ? "auto" : "none"}
  onClick={() => 
    textFieldValue && isChatbotAllowed() && correctChiefComplaint(textFieldValue)
  }
  bg={isChatbotAllowed() ? "transparent" : "gray.100"}
  _hover={
    textFieldValue && isChatbotAllowed() 
      ? { bg: "gray.50", borderColor: "gray.300" } 
      : {}
  }
  title={
    !isChatbotAllowed() 
      ? "Please upgrade your subscription to use AI features"
      : !textFieldValue
      ? "Please enter text to enable AI suggestions"
      : "Get AI suggestions"
  }
>
  <Image 
    w="26px" 
    src="/assets/svgs/ai-star-outline.svg" 
    opacity={textFieldValue && isChatbotAllowed() ? 1 : 0.5}
    filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
  />
</Box>
            {/* <Box
              as="button"
              // onClick={}
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() =>
                textFieldValue && correctChiefComplaint(textFieldValue)
              }
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box> */}
            <PrimaryButton
              type="submit"
              buttonText="Submit"
              variant="grayBtn"
              isDisabled={
                isButtonDisabled ||
                !textFieldValue ||
                !actionAccessMain(16)?.create
              }
              btnStyle={{
                h: "2.5rem",
                w: "90%",
                p: "0",
                mr: "12px",
                ml: "12px",
                position: "sticky",
                bottom: "0",
                zIndex: "1",
                mx: "auto",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            />
          </HStack>
        </VStack>
      </Box>
      <DynamicModal
        ref={advanceCheifComplaints}
        modalHeader="Search Chief Complaint"
        modalWidth='36rem'
        modalHeight='19rem'
        hasFooter={false}
        modalBody={
          <Box px={4}> {/* Add padding to match modal edge spacing */}
            <Box position="relative" width="100%" mb={4}>
              <PrimaryInput
                variant="bothSide"
                inputType="text"
                inputPlace="Please provide your text"
                inputValue={searchValue}
                onChange={(e) => {
                  handleReportNameChange(handleAlphaDotAndSpace(e.target.value, 50))
                }}
                onFocus={handleInputFocus}
                boolProp={boolValForSuggestions}
                inputCssStyle={{
                  borderRadius: "8px",
                  paddingRight: "40px",
                  border: "1px solid #E6E7E9",
                  _focus: {
                    borderColor: "#3182ce",
                    boxShadow: "0 0 0 1px #3182ce"
                  }
                }}
              />
              
              <Image
                position="absolute"
                right="12px"
                top="50%"
                transform="translateY(-50%)"
                w="18px"
                h="18px"
                cursor="pointer"
                src="/assets/imgs/search.png"
                alt="Search"
              />
            </Box>
      
            {showReportNamesDropdown && labTestNamesFiltered.length > 0 && (
              <Box 
                position="relative"
                width="calc(100% - 2px)" 
                left="1px" 
                border="1px solid #E6E7E9"
                borderTop="none"
                borderRadius="0 0 8px 8px"
                // maxH="150px"
                maxH="145px"
                overflowY="auto"
                boxShadow="none"
                zIndex="999"
              >
                {labTestNamesFiltered.map((suggestion, index) => (
                  <Box
                    key={index}
                    p="12px"
                    borderBottom="1px solid #E6E7E9"
                    _hover={{ bg: "gray.50" }}
                    cursor="pointer"
                    onClick={() => handleSelectComplaint(suggestion)}
                  >
                    <Text fontSize="0.875rem" fontWeight="500">{suggestion.subtype}</Text>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        }
      />
    </Flex>
  );
};

export default DoctorComplaintInputCPUCard;
